export default __webpack_public_path__ + "static/media/zawodnik8.9d389fba.png";